const delay = (ms) => new Promise((resolve) => setTimeout(resolve, ms));
const delayCallback = (ms, callback) => setTimeout(callback, ms);

export const delayUtils = {
  delay,
  delayCallback,
};
